import React, { useEffect, useState } from 'react'
import { Badge, ListItem, Tooltip } from '@mui/material'
import './Message.css'
import moment from 'moment'
import { useMediaQuery } from 'react-responsive'
// import { el } from 'date-fns/locale'

const ActiveSellers = (props) => {
    const [firstSeller, setFirstSeller] = useState()

    const assignFirstSeller = (element, index) => {
        if (element && index === 0) {
            setFirstSeller(element)
        }
    }

    const isSmallDesktop = useMediaQuery({ query: '(max-width: 1400px)' })

    useEffect(() => {
        if (firstSeller) {
            firstSeller.click()
        }
    }, [firstSeller, props.isArchive])

    return (
        <ul className="activeSellers">
            {props.sellers &&
                props.sellers.map((seller, index) => (
                    <ListItem
                        button
                        key={index}
                        className={
                            props.selectedSeller === seller.userid
                                ? 'active'
                                : ''
                        }
                        onClick={(e) =>
                            props.onClick(
                                e,
                                index,
                                seller.userid,
                                seller.project_id
                            )
                        }
                        ref={(element) => assignFirstSeller(element, index)}
                    >
                        {isSmallDesktop ? null : (
                            <span className="material-icons userAvatar">
                                account_circle
                            </span>
                        )}
                        <div className="d-flex justify-content-between flex-wrap w-100">
                            <div className="asContent d-flex justify-content-start align-items-start w-100 sellerDetailMsg flex-column">
                                <Tooltip
                                    title={seller.username}
                                    placement="top"
                                >
                                    <h4 className="asTitle">
                                        {seller.username}
                                        {/* {seller.first_name} {seller.last_name} */}
                                    </h4>
                                </Tooltip>
                                <h6 className="ml-0">
                                    {moment(seller.date_sent).format(
                                        'DD-MM-YYYY'
                                    )}
                                </h6>
                            </div>
                            <div className="asContent d-flex justify-content-between w-100 mt-2 align-items-center">
                                <h5 className="asSubject">
                                    {seller.message
                                        ? seller.message.split('<')[0]
                                        : 'Attachment Sent'}
                                </h5>
                                {seller.unreadcount > 0 && !props.isArchive ? (
                                    <Badge
                                        badgeContent={seller.unreadcount}
                                    ></Badge>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    </ListItem>
                ))}
        </ul>
    )
}

export default ActiveSellers
